import { FC } from 'react';
import EditProjectSectionAssigneeModal from './Edit/EditProjectSectionAssigneeModal';
import EditProjectSectionPriorityModal from './Edit/EditProjectSectionPriorityModal';
import EditProjectSectionRepairFollowUpModal from './Edit/EditProjectSectionRepairFollowUpModal';
import EditProjectSectionRepairSolutionModal from './Edit/EditProjectSectionRepairSolutionModal';
import EditProjectSectionRepairYearModal from './Edit/EditProjectSectionRepairYearModal';

export const ProjectListModals: FC = () => {
    return (
        <>
            <EditProjectSectionPriorityModal />
            <EditProjectSectionRepairSolutionModal />
            <EditProjectSectionRepairYearModal />
            <EditProjectSectionRepairFollowUpModal />
            <EditProjectSectionAssigneeModal />
        </>
    );
};
